export default {
  props: {
    // 是否在workbench页面
    judgeWorkbench: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 时间类名
      TimeClass: [0, 0, 0, 0, 0, 0, 0],
      // AM,PM
      Format: '',
      // 时区
      timeZone: '',
      // 定时器
      getCurrentTime: null
    };
  },
  created() {},
  mounted() {
    this.setdisplays();
    if (this.getCurrentTime) {
      clearInterval(this.getCurrentTime);
    }
    this.getCurrentTime = setInterval(this.setdisplays, 100);
  },
  methods: {
    // 设置每个显示数字几
    setdisplays() {
      const d = new Date();
      const time = this.transitionHourly(d);
      const TimeClass = time.split('');
      this.TimeClass = TimeClass;
    },
    // 24小时制转12小时制
    transitionHourly(time) {
      if (time) {
        let type = '';
        let hour = time.getHours();
        let min = time.getMinutes();
        let s = time.getSeconds();
        if (hour >= 0 && hour <= 11) {
          type = 'AM';
        } else {
          type = 'PM';
        }
        hour = hour >= 0 && hour < 10 ? `0${hour}` : hour;
        min = min >= 0 && min < 10 ? `0${min}` : min;
        s = s >= 0 && s < 10 ? `0${s}` : s;
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.Format = type;
        this.timeZone = timeZone;
        return `${hour}${min}${s}`;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.getCurrentTime);
  }
};